import React, { useState, useEffect } from 'react';
import { appliedRuleIcon, restartIcon } from "../../assets/images";
import { formatter, validate } from "../../utility";
import { Button } from 'react-bootstrap';
import { InputBase } from "../Helper/InputBase";
import { NormalizationConstants } from '../../constants';
import GeneralUtils from '../../utility/GeneralUtils';
import moment from 'moment';

const RICalcStepThree = (props) => {

  const {
    calc_p1RentAmount,
    calc_p2CPIYear,
    calc_p2CPIValue,
    calc_nextCPIUpdateDate,
    calc_p2MaxCPIAmountStandardRentIncrease,
    calcCPIValue,
    calc_p2MaxAdditionalRentIncrease,
    calc_p2MaxRentAmountStandardRentIncrease,
    calc_p2AppliedEligibleAmount,
    calc_p2MaxEligibleAmount,
    stepThreeSubmitted,
    phase2RentIncreaseDate,
    calc_p2IsServiceTimeAvailable,
    calc_p2RemainingEligibleAmount,
    isRentIncreaseAfterPhase2,
    calc_p2RentIncreaseDate,
  } = props?.phaseTwoData;

  const { calc_p1RemainingEligibleAmount, phase1RentAmountUsed } = props?.phaseOneData;

  const [stepThreeData, setStepThreeData] = useState({
    phase2RentAmount: props?.phaseTwoData?.phase2RentAmount || '',
    errors: {}
  });

  useEffect(() => {
    if (!calc_p2IsServiceTimeAvailable || !calc_p2CPIValue || !phase2RentIncreaseDate) {
      const stepThreeVars = setPhaseThreeVars();
      props?.setPhaseTwoData({...props?.phaseTwoData, ...stepThreeData, ...stepThreeVars, ...{  stepThreeSubmitted: true }});
    }
  },[])

  const { phase2RentAmount } = stepThreeData;

  const modifyClicked = () => {
    props?.setPhaseTwoData({...props?.phaseTwoData, ...{  stepThreeSubmitted: false }});
  }

  const getIsGeneratedNoticeAvailable = () => {
    //Calc_P2RemainingEligibleAmount != 0 and Calc_P2IsServiceTimeAvailable = true and IsRentIncreaseAfterPhase2 = No THEN Calc_IsGeneratedNoticeAvailable
    if((isRentIncreaseAfterPhase2 && calc_p2RemainingEligibleAmount <= 0) || (!calc_p2IsServiceTimeAvailable && calc_p2RemainingEligibleAmount <= 0) || !calc_p2CPIValue) return false;
    return true;
  }

  const setPhaseThreeVars = () => {
    const calc_p2UnusedEligibleAmount = Number(calc_p2MaxAdditionalRentIncrease) - Number(phase2RentAmount) < Number(calc_p2MaxAdditionalRentIncrease) ? 
      formatter.toFixedNumber(Number(calc_p2MaxAdditionalRentIncrease) - Number(phase2RentAmount), 3) 
      : Number(calc_p2MaxAdditionalRentIncrease)

    const calc_isGeneratedNoticeAvailable = getIsGeneratedNoticeAvailable();
    const calc_p2InPersonMinServiceDate = moment(calc_p2RentIncreaseDate).subtract(3, 'months').subtract(1, 'day');
    const calc_p2EmailDoorFaxMinServiceDate = moment(calc_p2RentIncreaseDate).subtract(3, 'months').subtract(4, 'days');
    const calc_p2RegMailMinServiceDate = moment(calc_p2RentIncreaseDate).subtract(3, 'months').subtract(6, 'days');

    const p2StepThreeData = {
      calc_p2UnusedEligibleAmount,
      calc_isGeneratedNoticeAvailable,
      calc_p2InPersonMinServiceDate,
      calc_p2EmailDoorFaxMinServiceDate,
      calc_p2RegMailMinServiceDate
    }

    GeneralUtils.log('----- PRINTING ALL PHASE 2 - STEP 3 VARIABLES -----', 'success');
    GeneralUtils.log(`
    calc_p2UnusedEligibleAmount: ${calc_p2UnusedEligibleAmount}\n
    calc_isGeneratedNoticeAvailable: ${calc_isGeneratedNoticeAvailable}\n
    calc_p2InPersonMinServiceDate: ${formatter.toDateDisplay(calc_p2InPersonMinServiceDate)}\n
    calc_p2EmailDoorFaxMinServiceDate: ${formatter.toDateDisplay(calc_p2EmailDoorFaxMinServiceDate)}\n
    calc_p2RegMailMinServiceDate: ${formatter.toDateDisplay(calc_p2RegMailMinServiceDate)}
    `, 'info')

    return p2StepThreeData;
  }

  const submitStepThree = () => {
    const validations = [
      {
        phase2RentAmount,
        validationRules: [{ minValue: phase1RentAmountUsed }, { maxValue: calc_p2MaxAdditionalRentIncrease }, { isRequired: true, errorMsg: 'Amount is required' }],
      },
    ]
    
    const validationErrors = validate(validations);
    if (Object.keys(validationErrors).length) {
      setStepThreeData({...stepThreeData, errors: validationErrors });
    } else {
      const stepThreeVars = setPhaseThreeVars();
      props?.setPhaseTwoData({...props?.phaseTwoData, ...stepThreeData, ...stepThreeVars, ...{  stepThreeSubmitted: true }});
    }
  }

  const changeHandler = e => {
    const { name, value } = e.target;
    if (stepThreeData?.[name] === undefined) return;
    setStepThreeData({...stepThreeData, [name]: value, errors: { ...stepThreeData?.errors, [name]: '' }})
  }

  const renderCpiNotAvailableError = () => {
    if (calc_p2CPIValue) return;
    return (
      <div className="validator__errors__error alert-error">
        <b>Annual Allowable Rent Increase not known.</b>&nbsp;This rent increase cannot be calculated until the annual allowable rent increase is known for the year {calc_p2CPIYear}. 
        This tool is updated each September with the annual allowable rate for the following year. 
        Based on the date you have selected for this rent increase, you can return to this site and calculate this rent increase on {formatter.toDateDisplay(calc_nextCPIUpdateDate, { fullMonth: true })}.
      </div>
    )
  }

  const renderRentIncreaseCalculations = () => {
    if (!calc_p2CPIValue) return;

    return <div>
    <div className="breakdown-title">Second Additional Rent Increase Calculation</div>
      <div className="validator__summary__item--faded">
        <div className="validator__summary__item__column-left">{formatter.toAmountDisplay(calc_p1RemainingEligibleAmount)}</div>
        <div className="validator__summary__item__column-right">Eligible amount remaining (not used in previous rent increases)</div>
      </div>
      <div className="validator__summary__item">
        <div className="validator__summary__item__column-left">{formatter.toAmountDisplay(phase1RentAmountUsed)}</div>
        <div className="validator__summary__item__column-right">Current monthly rent (before any rent increases in year)</div>
      </div>
      <div className="validator__summary__item">
        <div className="validator__summary__item__column-left">{formatter.toAmountDisplay(calc_p2MaxCPIAmountStandardRentIncrease)}</div>
        <div className="validator__summary__item__column-right">Maximum annual allowable rent increase amount ({formatter.toFixedNumber(calcCPIValue, 1)}% for {calc_p2CPIYear})</div>
      </div>
      <div className="validator__summary__item">
        <div className="validator__summary__item__column-left">{formatter.toAmountDisplay(calc_p2MaxRentAmountStandardRentIncrease)}</div>
        <div className="validator__summary__item__column-right">Rent amount with standard rent increase</div>
      </div>
      <div className="validator__summary__item">
        <div className="validator__summary__item__column-left">{formatter.toAmountDisplay(calc_p2AppliedEligibleAmount)}</div>
        <div className="validator__summary__item__column-right">Additional rent increase eligible amount for rent increase (max allowed 3% or {formatter.toAmountDisplay(calc_p2MaxEligibleAmount)})</div>
      </div>
      <div className="validator__summary__item">
        <div className="validator__summary__item__column-left">{formatter.toAmountDisplay(calc_p2MaxAdditionalRentIncrease)}</div>
        <div className="validator__summary__item__column-right">Maximum allowed rent amount with all rent increases applied</div>
      </div>
    </div>
  }

  const renderMaxAdditionalRule = () => {
    if (!calc_p2CPIValue) return;
    return <p className="ric__rule">
    <img className="w1-step-three__rule__icon" src={appliedRuleIcon} alt='' />
    <span>
      <b>Applied Rule</b>: The amount that can be applied to an additional rent increase in a year is either 3% of the rent amount after the annual allowable rent increase has been added, or the remaining eligible amount for the unit, whichever is less.
      <span className="w1-step-three__rule--success">&nbsp;<b>The maximum rent increase amount for the phase 2 additional rent increase is {formatter.toAmountDisplay(calc_p2AppliedEligibleAmount)}</b>.</span>
    </span>
  </p>
  }

  const renderRentIncreaseAmount = () => {
    if (!calc_p2IsServiceTimeAvailable || !calc_p2CPIValue || !phase2RentIncreaseDate) return;
    return (
      <div className="decision-questions__input-wrapper">
        <InputBase
          name='phase2RentAmount'
          startAdornment='$'
          disabled={stepThreeSubmitted}
          errors={stepThreeData?.errors?.phase2RentAmount}
          value={phase2RentAmount}
          cssClass='ric__step-three__input'
          type='number'
          label={`What is the new rent amount that will be imposed on ${formatter.toDateDisplay(phase2RentIncreaseDate, { fullMonth: true })}?`}
          maxLength={NormalizationConstants.maxDollarLength}
          handleChange={changeHandler}
        />
      </div>
    )
  }

  return (
    <div className="ric__step-three">
      { renderCpiNotAvailableError() }
      { renderRentIncreaseCalculations() }
      { renderMaxAdditionalRule() }
      { renderRentIncreaseAmount() }
      { calc_p2IsServiceTimeAvailable && calc_p2CPIValue && phase2RentIncreaseDate ? <div className="ric__buttons hide-print">
        <Button variant="success" onClick={() => submitStepThree()} disabled={stepThreeSubmitted}>Continue</Button>
        { stepThreeSubmitted ? <span className="w1-step-one__modify" onClick={() => modifyClicked()}><img src={restartIcon} alt=""/> Modify</span> : null }
      </div> : null }
    </div>
  )
}

export default RICalcStepThree;